module.exports = __webpack_public_path__ + "img/offer-icon.f13c68b1.png";